import React from "react";
import DND from "../pages/canvas/paper/dndhandler";
import Render from "../pages/canvas/paper/render";

export default function Dataloader(props) {
  if (props.children.length === 0) {
    return (
      <div
        ref={props.editorRef}
        style={{
          flexGrow: props.block.props.flexGrow,
          minHeight: 40,
          minWidth: 40,
          visibility: props.block.hidden ? "hidden" : "unset",
          position: "relative",
        }}
      />
    );
  }
  return (
    <div
      ref={props.editorRef}
      style={{
        flexGrow: props.block.props.flexGrow,
        visibility: props.block.hidden ? "hidden" : "unset",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        //width: "100%",
      }}
    >
      {props.children.map((block, index) => {
        const newPath = [...props.path];
        newPath.push(index);

        return (
          <DND key={block.id} index={index} path={newPath} block={block}>
            <Render />
          </DND>
        );
      })}
    </div>
  );
}
